import { render } from "./ButtonLanguage.vue?vue&type=template&id=9bffd230&ts=true"
import script from "./ButtonLanguage.vue?vue&type=script&lang=ts"
export * from "./ButtonLanguage.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__